export default __webpack_public_path__ + "static/media/work2.c112bda6.png";